<template>
  <PageContent class="batch-edit-wrapper">
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2 type="w6" title="Business Information" @nextClick="commitData()" mode="edit">
      <template v-slot:title-solt>
        <!-- <span class="btn-action">EDIT</span> -->
      </template>
      <template v-slot:content-solt>
        <div class="underline">
          <BusinessDetail ref="detailForm" v-model="detailData" />
        </div>
        <div class="underline">
          <BusinessAddr ref="addrForm" v-model="addressData" :selectOptions="selectOptions" />
        </div>
          <div class="radioBox">
          <el-form ref="BdoRadioData">
            <el-form-item label="Do you own at least 20% of the business?" prop="least20">
              <BdoRadios :value="least20" @onClick="updateRadioValue" />
            </el-form-item>
          </el-form>
          </div>

        <Signatory ref="Signatory" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
import BusinessDetail from "../forms/NewMerchantCorpD.val";
import BusinessAddr from "../forms/NewMerchantCorpE.val";
import Signatory from "../components/Signatory"
import API from "@/api";
import {provinceData, cityData} from "../../common-data/config";
import barangayData from "../../common-data/barangay-data";

export default {
  name: "EditBusinessInfo",
  components: {
    BusinessDetail,
    BusinessAddr,
    Signatory,
  },
  data() {
    return {
      addressData: "",
      detailData: "",
      least20: "",
      status1: true,
      status2: true,
      selectOptions: {
        province: provinceData,
        city: [],
        barangay: []
      },
    };
  },
  created() {
    API.getBdoProcessData({
      pageNo: "999",
      token: this.getCookieItem("token"),
    }).then((res) => {
      if (res.success) {
        Object.assign(this.addressData, res.obj.businessAddress);
        this.$refs.addrForm.updateDataForm(this.addressData);
        Object.assign(this.detailData, res.obj.businessDetails);
        this.$refs.detailForm.updateDataForm(this.detailData);
        this.least20 = res.obj.businessOwnership.least20;
        this.$refs.Signatory.formData.formArr = res.obj.businessauthorizedSignatories.businessauthorized
      }
    });
  },
  watch: {
    'addressData.province': function(val) {
      if (!this.status1) {
        this.$set(this.addressData, 'city', '')
      } else {
        this.status1 = false
      }
      this.selectOptions.city = val ? cityData[val] : []
    },
    'addressData.city':function(val) {
      if (!this.status2) {
        this.$set(this.addressData, 'barangay', '')
      } else {
        this.status2 = false
      }
      this.selectOptions.barangay = barangayData[val || ''] || []
    },
    'addressData.barangay':function(val) {
      if (this.selectOptions.barangay.length > 0 && val) {
        const data = this.selectOptions.barangay.filter(value => value.value === val)[0].zipCode
        this.$set(this.addressData, 'zipCode', data[0])
      } else {
        this.$set(this.addressData, 'zipCode', '')
      }
    },
  },
  methods: {
    updateRadioValue(val) {
      this.least20 = val
    },
    commitData() {
      let businessauthorized = this.$refs.Signatory.formData.formArr;
      Promise.all(
        [
          this.$refs.detailForm.$refs.appForm,
          this.$refs.addrForm.$refs.appForm,
          this.$refs.Signatory.$refs.formData,
        ].map((form) => {
          return new Promise((reslove) => {
            form.validate((valid) => {
              reslove(valid);
            });
          });
        })
      ).then((res) => {
        const [res1, res2, res3] = res;
        if (res1 && res2 && res3) {
          API.editBdoProcess({
            token: this.getCookieItem("token"),
            pageNo: `5,6,7,8`,
            businessAddress: { ...this.addressData },
            businessDetails: this.detailData,
            businessauthorizedSignatories: { businessauthorized },
            businessOwnership: { least20: this.least20 }
          }).then((res) => {
            if (res.success) {
              window.history.go(-1);
            }
          });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.panel-v2.content-area {
  margin: 16px 0;
}
.radioBox {
  margin-bottom: 40px;
  .radioTitle {
    margin-bottom: 4px;
    font-size: 16px;
    color: #2e2e2e;
    // font-family: Nunito;
  }
}
.underline {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 30px;
}
::v-deep .el-form.NewMerchantCorpE {
  .el-form-item {
    &:nth-child(6) {
      width: 26% !important;
    }
    &:nth-child(7) {
      width: 18% !important;
    }
  }
}
</style>
